import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Project, ProjectSynthesis } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  synthesis: ProjectSynthesis;
  retrieveProjectSynthesis(
    project: Boundaries["retrieveProjectSynthesis"]["request"],
  ): void;
}

function useRetrieveProjectSynthesis(
  project: Identifiable<Project>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isProjectSynthesisRetrievalRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isProjectSynthesisRetrievalRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isProjectSynthesisRetrievalRequestFailure(project),
    ),
    synthesis: useSelector(() => selector.getProjectSynthesis(project)),
    retrieveProjectSynthesis: core.retrieveProjectSynthesis,
  };
}

export { useRetrieveProjectSynthesis };
